import { useState, useEffect } from 'react';
import Icon from './AppIcon';

const MobileEmergencyBar = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handlePhoneClick = () => {
    window.location.href = 'tel:0827935785';
  };

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 lg:hidden transition-transform duration-300 ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="bg-card border-t border-border shadow-elevated">
        <button
          onClick={handlePhoneClick}
          className="w-full flex items-center justify-center gap-3 px-6 py-4 bg-accent text-accent-foreground font-semibold emergency-cta"
          aria-label="Call emergency number"
        >
          <Icon name="Phone" size={24} />
          <span className="font-accent text-lg">Emergency: 082 793 5785</span>
        </button>
      </div>
    </div>
  );
};

export default MobileEmergencyBar;